document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById('tags-panel');
  if (!popup) return;

  const closeBtn = document.getElementById('close-btn');

  function openPopup() {
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.style.display = 'none';
    document.body.style.overflow = '';
  }

  // Mostrar popup si tiene clase show al cargar
  if (popup.classList.contains('show')) {
    openPopup();
  }

  // Botón cerrar
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  // Cerrar al hacer click fuera del contenido
  popup.addEventListener('click', function(e) {
    if (e.target === popup) closePopup();
  });

  // Observer para detectar si la clase 'show' se añade después
  const observer = new MutationObserver(() => {
    if (popup.classList.contains('show')) {
      openPopup();
    } else {
      closePopup();
    }
  });

  observer.observe(popup, { attributes: true, attributeFilter: ['class'] });
});
